import type { TypeInternalItemProps } from "../types";

export const itemToString = (item: TypeInternalItemProps | null) => {
  return item ? item.id : "";
};

export const itemToKey = (item: TypeInternalItemProps | null) => {
  return item ? item.id : "";
};
